import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

const MentionTextarea = forwardRef(({ value, onChange, placeholder, rows = 1 }, ref) => {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [mentionQuery, setMentionQuery] = useState('');
    const [cursorPosition, setCursorPosition] = useState(null);
    const textareaRef = useRef(null);

    const [users, setUsers] = useState([]);
    useEffect(() => {
        fetch('https://api.fantasyworldtrpg.cz/echo/users.php')
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') setUsers(data.users);
            });
    }, []);

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        const cursor = e.target.selectionStart;
        onChange(newValue);
        setCursorPosition(cursor);

        const textUntilCursor = newValue.slice(0, cursor);
        const match = textUntilCursor.match(/@(\w{1,})$/);
        if (match) {
            const query = match[1].toLowerCase();
            setMentionQuery(query);
            const filtered = users.filter(u =>
                u.name.toLowerCase().startsWith(query) ||
                u.echo_nickname.toLowerCase().startsWith(query)
            );
            setSuggestions(filtered.slice(0, 5));
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (user) => {
        const text = value;
        const before = text.slice(0, cursorPosition).replace(/@(\w{1,})$/, `@${user.echo_nickname}`);
        const after = text.slice(cursorPosition);
        const newText = before + after;

        onChange(newText);
        setShowSuggestions(false);
    };

    // 💡 zpřístupníme ref (např. textareaRef.current.focus())
    useImperativeHandle(ref, () => ({
        focus: () => {
            textareaRef.current?.focus();
        },
        setValue: (text) => {
            onChange(text);
        },
        insertText: (insert, position = 'start') => {
            const current = textareaRef.current;
            if (!current) return;

            const cursor = current.selectionStart;
            const before = value.slice(0, cursor);
            const after = value.slice(cursor);
            const newText = before + insert + after;
            onChange(newText);
            setTimeout(() => {
                current.focus();
                current.setSelectionRange(cursor + insert.length, cursor + insert.length);
            }, 0);
        }
    }));

    return (
        <div className="position-relative w-100">
            <textarea
                ref={textareaRef}
                className="form-control"
                rows={rows}
                placeholder={placeholder}
                value={value}
                onChange={handleInputChange}
            />
            {showSuggestions && suggestions.length > 0 && (
                <ul className="list-group position-absolute bg-white shadow mt-1" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto', width: '100%' }}>
                    {suggestions.map(user => (
                        <li
                            key={user.id}
                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            onClick={() => handleSuggestionClick(user)}
                            style={{ cursor: 'pointer' }}
                        >
                            @{user.echo_nickname}
                            <span className="text-muted small">{user.name}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
});

export default MentionTextarea;
